import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import styled from 'styled-components';
import { g as getFocusableElements } from '../../LocalModules/storm-ui-utils/dist/esm/focusableElements/getFocusableElements-BjFtn5aB-BjFtn5aB.js';
import { K as KEYBOARD_KEYNAMES } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-CVa_vjg3-CVa_vjg3.js';

const StyledList = /*#__PURE__*/styled('ul').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1g1691r-0"
})(["list-style:none;padding:0;> li:not(:last-child){margin-block-end:", ";}"], ({
  theme
}) => theme.spacing.xxxxsmall.default);

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const MenuList = ({
  children,
  ...rest
}) => {
  const listRef = useRef(null);
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    const focusableElements = getFocusableElements(listRef.current);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    const currentIndex = focusableElements.indexOf(document.activeElement);
    let newFocusIndex = currentIndex;
    switch (key) {
      case KEYBOARD_KEYNAMES.ARROW_DOWN:
        newFocusIndex = currentIndex + 1;
        if (document.activeElement === lastFocusableElement) {
          newFocusIndex = focusableElements.length - 1;
        }
        event.preventDefault();
        break;
      case KEYBOARD_KEYNAMES.ARROW_UP:
        newFocusIndex = currentIndex - 1;
        if (document.activeElement === firstFocusableElement) {
          newFocusIndex = 0;
        }
        event.preventDefault();
        break;
      case KEYBOARD_KEYNAMES.HOME:
        newFocusIndex = 0;
        event.preventDefault();
        break;
      case KEYBOARD_KEYNAMES.END:
        newFocusIndex = focusableElements.length - 1;
        event.preventDefault();
        break;
    }
    focusableElements[newFocusIndex].focus();
  }, []);
  return /*#__PURE__*/React__default.createElement(StyledList, _extends({
    ref: listRef,
    role: "menu",
    onKeyDown: onKeyDown
  }, rest), children);
};

export { MenuList as M, StyledList as S };
//# sourceMappingURL=MenuList-B0przfyd.js.map
